import { DSCategoryPage } from 'shared-definitions/types'
import { ApiCategoryPageProps } from 'data-source/types.wp'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import {
  onePostWithAuthorMapper,
  OnePostWithAuthorMapperOpts,
} from 'data-source/mappers/onePostWithAuthorMapper'
import { paginationMapper } from 'data-source/mappers/paginationMapper'

interface CategoryPageMapperOpts extends MetaMapperOpts, OnePostWithAuthorMapperOpts {
  pagePath: string
  slug: string
}

export function categoryPageMapper(
  input: ApiCategoryPageProps,
  opts: CategoryPageMapperOpts
): DSCategoryPage {
  return {
    slug: opts.slug,
    sections: null,
    meta: metaMapper({ ...input, content: {} }, [input.title], opts),
    ampPagePath: null,
    head: headPropsMapper(input.head),
    pagePath: opts.pagePath,
    resource: 'category-page',
    subtitle: null,
    title: input.title,
    posts: {
      ...paginationMapper(input.content),
      items: input.content.posts.map(i => onePostWithAuthorMapper(i, opts)),
    },
  }
}
